import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { colors } from 'theme/colors';

export const StyledDocumentFormContainer = styled(Grid)`
  background: ${colors.gray50};
  border-radius: 4px;
  padding: 20px;
  align-items: flex-start;
`;
export const StyledInternalDescription = styled(Grid)`
  background: ${colors.gray100};
  border: 1px solid ${colors.gray200};
  border-radius: 4px;
  padding: 20px;
`;
